import React from 'react';
import { Combo } from 'fw/forms';
import * as API from 'modules/app/API'

class CertificationStatusCombo extends React.PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
        this._isMounted = false;
    }

    completed = () => { return this._ctrl.completed(); }
    flag = () => { return this._ctrl.flag(); }

    componentDidMount = () => {
        this._isMounted = true;

        this.loadCertificationStatus(this.props.queueTypeCode);
    }

    loadCertificationStatus = (queueTypeCode) => {
        const params = queueTypeCode ? { queueTypeCode: queueTypeCode } : {};
        API.Admin.get('/queue/getCertificationStatus', params,
            {
                success: (r) => {
                    this._isMounted && this.setState({
                        items: r.data.items.map((item) => { return { label: item.description, value: item.certificationStatusCode } }),
                    });
                }
            }, { block: false });
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.queueTypeCode !== this.props.queueTypeCode)
            this.loadCertificationStatus(nextProps.queueTypeCode);
    }

    render() {
        return (
            <Combo
                {...this.props}
                placeholder={this.props.placeholder ? this.props.placeholder : "Certification Status"}
                items={this.state.items}
                searchable={true}
                ref={(c) => { this._ctrl = c }} />
        )
    }
}

export default CertificationStatusCombo;

// Mark this as a form component
CertificationStatusCombo.defaultProps = {
    formControl: true,
    managed: false
};



// WEBPACK FOOTER //
// ./src/areas/shared/controls/certificationStatusCombo/CertificationStatusCombo.js